import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { useDispatcher } from '../../../store.decorator';
import {
    CategoryAction,
    EventCentreHookService,
    Item,
    ItemAction,
} from '../core';

import { TranslationKeyMap } from './event-centre-dialog.i18n';
import { EventCentreDialogService } from './event-centre-dialog.service';
import { ViewItem } from './model/view-item.model';
import { toggleItemExpand } from './state/toggle-item-expand.action';
import { updateItems } from './state/update-items.action';

@Component({
    selector: 'cmps-event-centre-dialog',
    templateUrl: './event-centre-dialog.component.html',
    host: {
        class: 'cmps-event-centre-dialog',
    },
})
export class EventCentreDialogComponent implements OnInit, OnDestroy {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(
        private readonly _router: Router,
        /** @private */ readonly _service: EventCentreDialogService,
        private readonly _actionHookService: EventCentreHookService,
    ) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {}

    /** @private */
    _onCategoryActionClick(action: CategoryAction): void {
        this._actionHookService.categoryActionInvoked(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
        );
    }

    /** @private */
    _onToggleExpandClick(item: Item): void {
        useDispatcher(
            this._service,
            toggleItemExpand({
                items: [item],
            }),
        );
    }

    /** @private */
    _onToggleReadClick(item: ViewItem, byExpand?: boolean): void {
        if (byExpand && (item.expanded || item.read)) {
            return;
        }
        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: { read: !item.read, delete: item.deleted },
            }),
        );
    }

    /** @private */
    _onDeleteClick(item: Item): void {
        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: { read: true, delete: true },
            }),
        );
    }

    /** @private */
    _onActionClick(item: Item, action: ItemAction): void {
        if (action.url != null && action.url.trim().length > 0) {
            void this._router.navigateByUrl(action.url);
            useDispatcher(
                this._service,
                updateItems({
                    items: [item],
                    patch: { read: !item.read, delete: item.deleted },
                }),
            );
            this._service.close();
        } else {
            const ret = this._actionHookService.actionInvoked(item, action);
            if (ret) {
                this._service.close();
            }
        }
    }
}
